import {useNavigate, useParams} from "react-router-dom";
import {useReadFaqDetail} from "../hooks/useReadFaqDetail";
import {useCallback} from "react";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";

export const FaqDetail = () => {
    const {id} = useParams();
    const navigate = useNavigate();

    const {data} = useReadFaqDetail({id: id || ''});

    const getIsNoticeTxt = useCallback((isNotice: string | undefined) => {
        switch (isNotice) {
            case 'Y':
                return '공지';
            case 'N':
                return '일반';
            case 'U':
                return '비활성화';
            default:
                return '';
        }
    }, []);

    if (!id) {
        alert("잘못된 접근입니다.");
        navigate(`${process.env.PUBLIC_URL}/support/faq/list`, {replace: true});
        return <></>;
    }

    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">FAQ 상세보기</h3>
                    <div className="filter_toolbar">
                        <button
                            className="btn btn-outline-primary w-100px h-38px"
                            onClick={() => navigate(-1)}>
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt=""/>
                            목록
                        </button>
                        <AuthorityChecker authorityNames={['faqWriteYn']}>
                            <button
                                className="btn btn-secondary w-100px h-38px"
                                onClick={() => navigate(`${process.env.PUBLIC_URL}/support/faq/update/${id}`, {replace: true})}>
                                수정
                            </button>
                        </AuthorityChecker>
                    </div>
                </div>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                        <tr>
                            <th colSpan={2} style={{width: "12.5%"}}>제목</th>
                            <td>{data?.title || ''}</td>
                        </tr>
                        <tr>
                            <th colSpan={2}>작성자/등록일</th>
                            <td>{data?.userName} | {data?.regAt}</td>
                        </tr>
                        <tr>
                            <th rowSpan={5}>기본정보</th>
                            <th style={{width: "6.5%"}}>유형</th>
                            <td>{data?.topicType}</td>
                        </tr>
                        <tr>
                            <th>제품군</th>
                            <td>{data?.newName}</td>
                        </tr>
                        <tr>
                            <th>벤더</th>
                            <td>{data?.productVendor}</td>
                        </tr>
                        <tr>
                            <th>카테고리</th>
                            <td>{data?.productCategory}</td>
                        </tr>
                        <tr>
                            <th>구분</th>
                            <td>{getIsNoticeTxt(data?.isNotice)}</td>
                        </tr>
                        <tr style={{height: "249px"}}>
                            <th colSpan={2}>내용</th>
                            <td style={{verticalAlign: "top"}}
                                dangerouslySetInnerHTML={{__html: data?.body ?? ''}}></td>
                        </tr>
                        <tr>
                            <th colSpan={2}>첨부파일</th>
                            <td>
                                <div className="tbl_files_outer">
                                    {data?.fileVOList.length !== 0 && <ul className="list_files">
                                        {data?.fileVOList.map((item) => <li>
                                            <a href={`${process.env.REACT_APP_SERVER_URL}api/customer/support/download_support_file?fileKey=${encodeURIComponent(item.fileKey)}&fileOrgname=${encodeURIComponent(item.fileOrgname)}&fileUrl=${encodeURIComponent(item.fileUrl)}`}>
                                                {item.fileOrgname}
                                            </a>
                                        </li>)}
                                    </ul>}
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
